import { graphql } from './utils/graphql';

export type Status = ReturnType<typeof graphql.scalar<'Status'>>;

export const Status = {
  ERROR: 'ERROR',
  NOT_FOUND: 'NOT_FOUND',
  OK: 'OK',
} as const satisfies Record<Status, Status>;

export type OrderDirection = ReturnType<typeof graphql.scalar<'OrderDirection'>>;

export const OrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const satisfies Record<OrderDirection, OrderDirection>;

export type FilterOperator = ReturnType<typeof graphql.scalar<'FilterOperator'>>;

export const FilterOperator = {
  AND: 'AND',
  EQUALS: 'EQUALS',
  GT: 'GT',
  ILIKE: 'ILIKE',
  LT: 'LT',
  NOT_EQUALS: 'NOT_EQUALS',
  OR: 'OR',
  STARTS_WITH: 'STARTS_WITH',
} as const satisfies Record<FilterOperator, FilterOperator>;

export type OrderInput = {
  direction: OrderDirection;
  field: string;
};

export type InnerFilterInput = {
  operator: FilterOperator;
  value: unknown;
};

export type FilterInput = {
  field: string;
  filters: Array<InnerFilterInput>;
  operator: FilterOperator;
  value: unknown;
};

export type FavouriteType = ReturnType<typeof graphql.scalar<'FavouriteType'>>;

export const FavouriteType = {
  POST: 'POST',
} as const satisfies Record<FavouriteType, FavouriteType>;

export type GameInputType = ReturnType<typeof graphql.scalar<'GameInputType'>>;

export const GameInputType = {
  IMAGE_SELECT: 'IMAGE_SELECT',
  MULTI_SELECT: 'MULTI_SELECT',
  OPTIONS_GROUP: 'OPTIONS_GROUP',
  RADIO_GROUP: 'RADIO_GROUP',
  SINGLE_SELECT: 'SINGLE_SELECT',
} as const satisfies Record<GameInputType, GameInputType>;

export type GameSlotType = ReturnType<typeof graphql.scalar<'GameSlotType'>>;

export const GameSlotType = {
  BACKGROUND_IMAGE: 'BACKGROUND_IMAGE',
  BADGE: 'BADGE',
  TAG: 'TAG',
} as const satisfies Record<GameSlotType, GameSlotType>;
